import {Component, Input, OnInit, ElementRef} from '@angular/core';
import {Router, NavigationExtras} from '@angular/router';
import { PageNotificationService, GadgetApiService} from '@signature-it/ngx-generic/services';

@Component({
    selector: 'bar2-gadget',
    templateUrl: './bar2.gadget.html',
    styleUrls: ['./bar2.gadget.scss'],
    standalone: false
})
export class Bar2Gadget implements OnInit {
    @Input() title_before: string;
    @Input() title_after: string;
    @Input() width: number = 200;
    @Input() colors: string[];
    @Input() btnLink: string;

    percentage: string;
    usageWidth: string = '0px';
    showGadget: boolean = false;

    constructor(
        protected notifySvc: PageNotificationService,
        public router: Router,
        protected gadgetApiSvc: GadgetApiService,
        protected element: ElementRef) {
    }

    ngOnInit() {
        this.getData();
    }


    getData() {
        this.gadgetApiSvc.getBar2Data()
            .subscribe(
                res => {
                    if (res && res['num']) {
                        this.percentage = res['num'];
                        this.usageWidth = (parseFloat(res['num']) * this.width / 100) + 'px';
                        this.showGadget = true;
                    } else {
                        this.notifySvc.set('Some Error Occurred').show();
                    }
                },
                error => {
                    this.notifySvc.set(error).show();
                }
            );
    }
}
